import React, { useEffect, useLayoutEffect, useRef } from "react";
import Navigation from "../components/Navigation";
import reflectBlurred from "../images/reflectBlurred.png";
import Main from "../components/Main";
import History from "../components/History";
import SplitterImage from "../components/SplitImage";
import Flagmans from "../components/Flagmans";
import Products from "../components/Products";
import BuyBlock from "../components/BuyBlock";
import Footer from "../components/Footer";
import { checkAndSetStats } from "../helpers/helpers";
import SEO from "../components/SEO";

function Harmony() {
    const doesStatsSent = useRef(false);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#DAD7DD";
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("reflectPage");
            doesStatsSent.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="bg-reflect">
            <SEO
                title="Колекція Reflect"
                description="Reflect — сучасна колекція ювелірних виробів від TSATSKY. Прикраси, що відображають вашу індивідуальність та стиль."
                url="/reflect"
                collection={{ name: "Reflect", description: "Сучасна колекція ювелірних виробів" }}
            />
            <Navigation showBack backTo="/" variant="light" />
            <div className="reflect_main_wrapper lg:bg-center">
                <Main
                    path="reflect"
                    logoImage={
                        "https://i.ibb.co/G48Y4FSW/LOGO-KOLOROVI-finish-03-1.png"
                    }
                    firstTitleLine={"Унікальна коллекція від"}
                    textColor="text-black"
                    logoClassNames="my-6"
                    logoAlt="reflect Logo"
                    buttonClassNames="reflect-button"
                    borderStyles="border-reflectDark"
                    defaultImage={reflectBlurred}
                />
            </div>

            <div className="bg-reflectDark">
                <History
                    path="reflect"
                    containerClassNames="bg-reflect text-black"
                    defaultImage={reflectBlurred}
                />
                <SplitterImage borderStyles="border-reflectDark shadow-bottom" />

                <Flagmans containerClassNames="text-black bg-reflect" />
                <Products
                    path="reflect"
                    containerClassNames="text-black bg-reflect"
                    productTextStyles={`text-black`}
                    productArticleStyles={`text-black`}
                    buttonStyles="bg-reflectDark hover:bg-reflectDarkHover text-white"
                    defaultImage={reflectBlurred}
                />

                <BuyBlock
                    buttonClassNames={"bg-reflectDark"}
                    buttonTextClassNames={"text-reflect"}
                    containerClassNames="text-black bg-reflect py-4"
                />
                <Footer
                    containerClassNames={"bg-reflectDark text-reflect"}
                    isDark
                />
            </div>
        </div>
    );
}

export default Harmony;
